<app-modal [(active)]="active">
    <div content>Are you sure you want to delete this post?</div>
    <div buttons>
        <div class="buttons is-right">
            <button class="button is-white">Cancel</button>
            <button class="button is-danger is-right" (click)="onRemove()">Delete</button>
        </div>
    </div>
</app-modal>